
/* injects from baggage-loader */

import moment from "moment";
import Config from "../../../config/main";
export const getRegionCompetition = (sportAlias, gameType) => {
    let req = {
        "source": "betting",
        "what": {
            "region": ["name", "alias", "order", "id"],
            "competition": ["id", "name", "alias", "order"]
        },
        "where": {
            "game": {
                "@or": [{"type": {"@in": [0, 2]}}, {"visible_in_prematch": 1}]
            },
            "sport": {
                "alias": sportAlias,
                "type": {"@in": [0, 2, 5]}
            }
        }
    };
    if (gameType === "today") {
        req.where.game = {
            "@or": [
                {
                    "start_ts": {
                        '@gte': moment().startOf("day").unix(),
                        '@lte': moment().endOf("day").unix()
                    },
                    "type": {"@in": [0, 2]}
                }
            ]
        };
    }
    if (gameType === "live") {
        req.where.game = {type: 1};
    }
    return req;
};

export const getSwarmSubscriptionRequestRegions = (sportAlias, timeFilter, isForHashing, isAsian, gameType) => {
    let req = {
        "source": "betting",
        "what": {
            "sport": [["id", "name", "alias"]],
            "region": ["name", "alias", "order", "id"],
            "competition": ["id", "name", "alias", "order"],
            "game": "@count"
        },
        "where": {
            "game": {
                "@or": [{"type": {"@in": [0, 2]}}, {"visible_in_prematch": 1}]
            },
            "sport": {
                "type": {"@in": [0, 2, 5]}
            }
        }
    };

    if (sportAlias != 'all' && sportAlias !== 'betBuilder')
        req.where.sport.alias = sportAlias;

    // if (isAsian) {
    //     req.where.market = {
    //         '@or': [{
    //             'display_key': 'WINNER'
    //         }, {
    //             'display_key': 'HANDICAP',
    //             'main_order': {
    //                 '@in': [1]
    //             }
    //         }, {
    //             'display_key': 'TOTALS',
    //             'main_order': {
    //                 '@in': [1]
    //             }
    //         }, {
    //             'display_key': 'OUTRIGHT'
    //         }]
    //     };
    // }
    if (timeFilter === 999 && Config.enableTodayButtonOnSport) {
        req.where.game = {
            "@or": [{"type": {"@in": [0, 2]}}, {"visible_in_prematch": 1}]
        };
    }
    if (timeFilter === 0 && Config.enableTodayButtonOnSport) {
        let oneDayDate = moment().unix();
        req.where.game = {
            "@or": [
                {
                    "start_ts": {
                        '@gte': oneDayDate,
                        '@lte': oneDayDate + 86400
                    },
                    "type": {"@in": [0, 2]}
                },
                { "visible_in_prematch": 1 }
            ]
        };
    }
    if (gameType === "esports") {
        req.where.game = {
            "@or": [{"type": {"@in": [0, 1, 2]}}, {"visible_in_prematch": 1}]
        };
    }
    if (timeFilter && !Config.enableDayFormatInPrematchLeftMenu && timeFilter !== 999) {
        const gte = Config.enableOneDayRangeFilterPrematch ? (timeFilter - 24) * 3600 : 0;

        req.where.game.start_ts = {
            '@now': {
                '@gte': Config.enableDayFormatInPrematchLeftMenu ? moment().startOf("day").unix() + (timeFilter * 2) : gte,
                '@lt': Config.enableDayFormatInPrematchLeftMenu ? moment().endOf("day").unix() + timeFilter : timeFilter * 3600
            }
        };
    } else if (timeFilter && Config.enableDayFormatInPrematchLeftMenu && timeFilter !== 999) {
        var newDate = moment().startOf('day').unix() + timeFilter * 24 * 60 * 60;
        if (timeFilter === (-1)) {
            newDate = moment().startOf('day').unix() + 0 * 24 * 60 * 60;
        }
        req.where.game.start_ts = {
            '@gte': newDate,
            '@lt': newDate + 86400
        };
    }

    if (gameType === "live") {
        req.where.game = {type: 1};
    }

    if (gameType === "topGames") {
        req.where.game = {
            "type": {"@in": [0, 2]},
            "promoted": true
        };
    }

    if (gameType === "today") {
        req.where.game = {
            "@or": [
                {
                    "start_ts": {
                        '@gte': moment().startOf("day").unix(),
                        '@lte': moment().endOf("day").unix()
                    },
                    "type": {"@in": [0, 2]}
                },
                { "visible_in_prematch": 1 }
            ]
        };
    }
    return req;
};